import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '../configs';

@Component({
  selector: 'app-logout-callback',
  templateUrl: './logout-callback.component.html',
  styleUrls: ['./logout-callback.component.css']
})
export class LogoutCallbackComponent implements OnInit {

  constructor(private appconfig:AppConfigService) { }

  ngOnInit(): void {    
    window.location.href=this.appconfig.identityServerUrl;
  }

}
